import { render } from "./App.vue?vue&type=template&id=7c9e89b3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7c9e89b3&lang=scss"

import exportComponent from "C:\\wamp64\\www\\dev\\skopos-varejista\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__